export default {
  computed: {
    anyUnarchivedTags() {
      return (
        this.allRemarkTags &&
        Object.values(this.allRemarkTags).some((t) => !t.archived)
      )
    },
  },
}
